import { Component, Input, OnInit } from '@angular/core';
import { MarketingCarousel } from '@app/models/MarketingCarousel';

@Component({
  selector: 'app-home-page-carousel-tab',
  templateUrl: './home-page-carousel-tab.component.html',
  styleUrls: ['./home-page-carousel-tab.component.scss', './home-page-carousel-tab.component.css']
})
export class HomePageCarouselTabComponent implements OnInit {
  @Input() public carouselSlides: MarketingCarousel[] = [];
  public publicSlides: MarketingCarousel[] = [];

  constructor() { }

  ngOnInit(): void {
    this.publicSlides = this.carouselSlides.slice(0, 15);
  }

  public slideConfig = {
    'slidesToShow': 1,
    'slidesToScroll': 1,
    'arrows': false,
    'dots': true,
    'autoplay': true,
    'infinite': true,
    'autoplaySpeed': 5000,
    'adaptiveHeight': true
  };

  public arrowsGap = this.publicSlides.length * 20;
}
